// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  COMMON_ADD_CART_COUNT,
} from './constants';

export function addCartCount() {
  return {
    type: COMMON_ADD_CART_COUNT,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COMMON_ADD_CART_COUNT:
      return {
        ...state,
        fetchGetShoppingCarTotal: state.fetchGetShoppingCarTotal + 1,
        fetchGetShoppingCarSuccess: JSON.parse(localStorage.getItem('shoppingCartData'))
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/common/redux/addCartCount.js